
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import { GetContentDetail } from "@/request/common";
import Report from "@/components/template-transfer-pc/report/report.vue";
@Component({
  components: {
    MainHeader,
    Report,
  },
})
export default class Name extends Vue {
  private data: any = [];
  private getData() {
    this.data.forEach((ele: any) => {
      GetContentDetail(this, ele.id).then((res: any) => {
        ele.data = res.data;
        this.$forceUpdate();
      });
    });
  }
  private mounted() {
    if (this.$route.query.ids) {
      const ids: any = JSON.parse(this.$route.query.ids as any);
      this.data = [];
      ids.forEach((ele: any) => {
        const obj: any = {
          id: ele,
          data: {},
        };
        this.data.push(obj);
      });
      this.getData();
    }
  }
}
